import { render, staticRenderFns } from "./activity-xfans_animation.vue?vue&type=template&id=1348f862&scoped=true&"
import script from "./activity-xfans_animation.vue?vue&type=script&lang=js&"
export * from "./activity-xfans_animation.vue?vue&type=script&lang=js&"
import style0 from "./activity-xfans_animation.vue?vue&type=style&index=0&id=1348f862&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1348f862",
  null
  
)

export default component.exports